module.exports = __webpack_public_path__ + "static/img/dlogo.30c70ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dlogo.png
// module id = LwjX
// module chunks = 12